<template>
    <div class="justify-content-center align-items-center text-center p-4 m-4">
      <h1 class="my-2 pb-4">{{ title }} 🛠</h1>
      <div class="my-2">
        <p><strong>{{ firstLine }}</strong><br>{{ secondLine }}</p>
        <p>- Real Links Engineering Team.</p>
      </div>
      <b-img src="https://i.ibb.co/nP5mRHZ/undraw-Maintenance-re-59vn.png" class="w-50 m-2 pt-3" alt="Maintenance Image" center/>
    </div>
</template>

<script>

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    firstLine: {
      type: String,
      required: true,
    },
    secondLine: {
      type: String,
      required: true,
    }
  },
};

</script>


// WEBPACK FOOTER //
// src/components/misc/UnderMaintenance.vue